import req from 'shared/req';

export interface StatusUpdate {
  statusType: string;
}

export interface FollowResponse {
  applicationStatus: string;
  banner: string;
  city: string;
  collegeId: string;
  earningRelationship: StatusUpdate;
  earningType: string;
  logo: string;
  name: string;
  reason: StatusUpdate;
  relationship: StatusUpdate;
  slug: string;
  state: string;
}

export interface FollowCollegeOptions {
  bucketShownEventId: string;
  collegeType: string;
  recommendationsShownEventId: string;
  source: string;
}

export class StudentCollegeService {
  static async followCollege(
    collegeId: string,
    options?: Partial<FollowCollegeOptions>
  ): Promise<FollowResponse> {
    const url = `/v1/colleges/${collegeId}/follow`;
    return (await req({url, method: 'POST', data: options})) as FollowResponse;
  }

  static async unfollowCollege(
    collegeId: string,
    options?: Partial<FollowCollegeOptions>
  ): Promise<FollowResponse> {
    const url = `/v1/colleges/${collegeId}/unfollow`;
    return (await req({url, method: 'POST', data: options})) as FollowResponse;
  }
}
